import Swiper, { Navigation, Keyboard } from 'swiper';
// import 'swiper/css';
import 'swiper/swiper-bundle.min.css'

export default () => {
  return {
      mounted() {

        const resourceSlider = new Swiper('.resource-slider', {
          modules: [Navigation, Keyboard],
          loop: true,
          slidesPerView: 1,
          spaceBetween: 10,
          watchSlidesProgress: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          navigation: {
            nextEl: '.resource-slider-next',
            prevEl: '.resource-slider-prev'
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1100: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }
        });

        const updateSlider = new Swiper('.update-slider', {
          modules: [Navigation, Keyboard],
          loop: true,
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
            nextEl: '.update-slider-next',
            prevEl: '.update-slider-prev'
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1100: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }
        });

        const relatedSlider = new Swiper('.related-slider', {
          modules: [Navigation, Keyboard],
          loop: true,
          slidesPerView: 1,
          spaceBetween: 10,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          navigation: {
            nextEl: '.related-slider-next',
            prevEl: '.related-slider-prev'
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1100: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
          }
        });

        const eventSlider = new Swiper('.event-slider', {
          modules: [Navigation, Keyboard],
          centeredSlides: true,
          loop: true,
          slidesPerView: 1,
          spaceBetween: 10,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          navigation: {
            nextEl: '.event-slider-next',
            prevEl: '.event-slider-prev'
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
          }
        });

      }
    }
  }
